import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=5d1881d5"
import script from "./CampaignDetail.vue?vue&type=script&lang=ts"
export * from "./CampaignDetail.vue?vue&type=script&lang=ts"
import style0 from "./CampaignDetail.vue?vue&type=style&index=0&id=5d1881d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports